export enum CheekSwabType {
    Center = 0,
    Donor = 1,
    Recipient = 2
}